module.exports = {
          srcSet: __webpack_public_path__ + "public/images/66e6cf783a9cc9013ebe203e2778ce02-1774.jpg"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/66e6cf783a9cc9013ebe203e2778ce02-1774.jpg",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/66e6cf783a9cc9013ebe203e2778ce02-1774.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/66e6cf783a9cc9013ebe203e2778ce02-1774.jpg"},
          
          width: 1774,
          height: 887
        }